export enum InventoryAdjustmentKind {
  ReturnRestock = "return_restock",
  FulfillmentCreated = "fulfillment_created",
  FulfillmentCancelled = "fulfillment_cancelled",
  PurchaseOrderReceived = "purchase_order_received",
  Manual = "manual",
  FulfillmentOrderCreated = "fulfillment_order_created",
  FulfillmentOrderCancelled = "fulfillment_order_cancelled",
  FulfillmentOrderEdited = "fulfillment_order_edited",
  SotInitialization = "sot_initialization",
  Unknown = "unknown",
  Count = "count",
  WmsTransfer = "wms_transfer",
  Supplies = "supplies",
  ShopifySync = "shopify_sync",
}
